"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Svg24LogoTwitter = function Svg24LogoTwitter(_ref) {
  var fill = _ref.fill,
      useDefaultColors = _ref.useDefaultColors,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["fill", "useDefaultColors", "title"]);

  return _react.default.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: useDefaultColors ? 'none' : fill,
    "aria-hidden": title === null || typeof title !== 'string' || title.length === 0
  }, props), _react.default.createElement("title", null, title), _react.default.createElement("path", {
    d: "M8.29 20c7.547 0 11.675-6.156 11.675-11.495 0-.175 0-.349-.012-.522A8.278 8.278 0 0 0 22 5.892a8.291 8.291 0 0 1-2.357.635 4.066 4.066 0 0 0 1.804-2.234 8.302 8.302 0 0 1-2.605.98 4.127 4.127 0 0 0-2.328-1.22 4.163 4.163 0 0 0-2.602.425 4.07 4.07 0 0 0-1.803 1.896 3.986 3.986 0 0 0-.26 2.584 11.793 11.793 0 0 1-4.684-1.225 11.618 11.618 0 0 1-3.773-2.996 3.989 3.989 0 0 0-.45 2.944 4.044 4.044 0 0 0 1.72 2.45A4.122 4.122 0 0 1 2.8 9.623v.052c0 .932.328 1.836.928 2.558a4.117 4.117 0 0 0 2.364 1.402 4.16 4.16 0 0 1-1.853.07 4.047 4.047 0 0 0 1.46 2.007 4.15 4.15 0 0 0 2.374.798A8.316 8.316 0 0 1 2 18.185a11.75 11.75 0 0 0 6.29 1.812",
    fill: useDefaultColors ? '#55ACEE' : fill
  }));
};

Svg24LogoTwitter.propTypes = {
  title: _propTypes.default.string,
  fill: _propTypes.default.string,
  useDefaultColors: _propTypes.default.bool
};
var _default = Svg24LogoTwitter;
exports.default = _default;